import {makeUseAxios} from 'axios-hooks';
import {axiosInstance} from '../remote/m2api/m2AxiosInstance';

export const useM2Axios = makeUseAxios({axios: axiosInstance, cache: false});
